import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { GameService } from '@app/dir_group_assignor/games/game.service';
import { OtherService } from '@services/other.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HelperClass } from '@classes/Helper-Classes';
import { HeadTitleComponent } from '@components/head-title/head-title.component';
import { FieldComponent } from '@components/__drop_inputs_matSelect/field/field.component';
import { DropFormCtrlComponent } from '@components/__drop_inputs_matSelect/dropFormCtrl/dropFormCtrl.component';
import { InputCtrlComponent } from '@components/__drop_inputs_matSelect/inputCtrl/inputCtrl.component';
import { BtnWrapComponent } from '@components/btn-wrap/btn-wrap.component';
import { BtnComponent } from '@components/btn/btn.component';
import { DropdownComponent } from '@components/__drop_inputs_matSelect/dropdown/dropdown.component';
import { DeviceService } from '@services/device.service';
import { NotificationService } from '@services/notification.service';
import { INewRequest } from '@services/base-api';

interface IMeProfileCalendarForm {
  calendarSyncUrl: FormControl<string>;
}

enum CaledarSystemToShow {
  apple = 'apple',
  google = 'google',
  microsoft = 'microsoft',
}

@Component({
  selector: 'app-popup-calendar-sync-details',
  standalone: true,
  imports: [CommonModule, HeadTitleComponent, FieldComponent, DropFormCtrlComponent,
    ReactiveFormsModule, FormsModule, InputCtrlComponent, BtnWrapComponent, BtnComponent, DropdownComponent],
  templateUrl: './popup-calendar-sync-details.component.html',
  styleUrls: ['./popup-calendar-sync-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopupCalendarSyncDetails extends HelperClass {
  form!: FormGroup<IMeProfileCalendarForm>;
  calendarSyncUrl: string | undefined;
  calendarSystemToShow?: CaledarSystemToShow | undefined;

  constructor(
    public gameS: GameService,
    public otherS: OtherService,
    private formBuilder: UntypedFormBuilder,
    private notificationS: NotificationService,
    public dialogRef: MatDialogRef<PopupCalendarSyncDetails>,
    @Inject(MAT_DIALOG_DATA) public dataPopup: {
      calendarSyncUrl: string;
      calendarSystemToShow?: CaledarSystemToShow;
    },
    public cd: ChangeDetectorRef,
    public deviceS: DeviceService,

  ) {
    super(cd);
    this.calendarSyncUrl = dataPopup.calendarSyncUrl;
    this.calendarSystemToShow = dataPopup.calendarSystemToShow;
    console.log('calendarSyncUrl', this.calendarSystemToShow);
    this.createForm();
  }

  private createForm(): void {
    this.form = this.formBuilder.group(
      {
        calendarUrl: [this.dataPopup.calendarSyncUrl || '']
      }
    );
  }

  get ctrl(): IMeProfileCalendarForm {
    return this.form?.controls;
  }

  copyUrl() {
    navigator.clipboard.writeText(this.calendarSyncUrl || '').then(() => {
      this.notificationS.showNotification_success({ message: 'The calendar sync URL has been copied' } as INewRequest, '');
    });
  }

  close(): void {
    this.dialogRef.close();
  }
}
